import { addHours } from 'date-fns';

export const formatHasuraDate = (date?: string) => (date ? addHours(new Date(date), 8) : undefined);
